var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInicioBalken(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9f9f9d;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_357",
    className: "cls-1",
    d: "M23.37,7.78L12.87.28c-.52-.37-1.22-.37-1.74,0L.63,7.78c-.67.48-.83,1.42-.35,2.09.48.67,1.42.83,2.09.35h0l.63-.45v12.73c0,.83.67,1.5,1.5,1.5h15c.83,0,1.5-.67,1.5-1.5v-12.73c.4.4.93.66,1.5.73.83,0,1.5-.67,1.5-1.5,0-.49-.23-.94-.63-1.22h0ZM18,21h-3v-4.5c0-1.66-1.34-3-3-3s-3,1.34-3,3v4.5h-3V7.63l6-4.29,6,4.29v13.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInicioBalken);
export default __webpack_public_path__ + "static/media/inicio_BALKEN.7baea48d23d229212a048149a27f800b.svg";
export { ForwardRef as ReactComponent };